$(document).ready(function (e) {
  $(".activate_acc").click(function () {
    if ($(".accept_data_treatment").is(":checked")) {
      $(".activate_acc").attr("type", "submit")
      $(".activate_acc").submit()
    } else {
      $(".error_accept_data").removeClass("d-none")
    }
  })

  // Verificar se existe um cookie de promoção enquanto anónimo
  var promo_url = Cookies.get("promo_url")
  if (
    typeof CID !== "undefined" &&
    CID !== null &&
    promo_url != undefined &&
    window.location.href != promo_url
  ) {
    window.location.href = promo_url
    $.removeCookie("promo_url")
  }

  // Forçar a aceitar os termos e condições ao fazer login
  if ($("#conta #terms").length) {
    $("#conta #terms").click(function () {
      if ($("#terms")[0].checked) {
        $(".login.btn").prop("disabled", false)
      } else {
        $(".login.btn").prop("disabled", true)
      }
    })
  }

  $("#account_orders a[data-reorder]").click(function (e) {
    e.preventDefault()
    var id = $(this).attr("data-reorder")
    showLoadingModal("A fazer nova encomenda...")
    $.post(ENDPOINT, {
      action: "marvanejo_reorder",
      store: 0,
      id: id,
    })
      .done(function (data) {
        console.log(data)
        data = JSON.parse(data)
        console.log(data)
        $(".loading_modal").remove()
        if (data.status == 1) {
          showLoadingModal("Encomenda realizada com êxito")
          setTimeout(function () {
            location.reload()
          }, 3000)
        } else {
          showLoadingModal(data.msg)
          removeLoadingModal()
        }
      })
      .fail(function (data) {
        $(".loading_modal").remove()
        showLoadingModal("Erro de comunicação. Tente novamente.")
        removeLoadingModal()
      })
  })
})

function changeQntyGrid(button) {
  var qnty_input = $(button).parent().parent().find("input[type=number]")
  var qnty = parseInt($(qnty_input).val())
  var qnty_step = parseInt($(qnty_input).attr("step"))
  var qnty_min = parseInt($(qnty_input).attr("min"))

  if ($(button).hasClass("quantity-up")) {
    qnty = qnty + qnty_step
    $(qnty_input).val(qnty)
  } else {
    if (parseInt($(qnty_input).val()) > qnty_min) {
      qnty = qnty - qnty_step
      $(qnty_input).val(qnty)
    }
  }
}
